<template>
  <v-text-field outlined v-model="input" :messages="priceString" @keyup="keyUp"
                :error-messages="error !== undefined ? error : []"
                :dense="dense" @keypress="isNumberKey" @input="handleInput"
                :readonly="readonly" append-icon="mdi-currency-usd" :label="label"/>
</template>
<script>
import num2perisan from "../../../num2perisan";
export default {
  name: "priceInput",

  props: ['value', 'error', 'label', 'dense', 'readonly'],

  model: {
    prop: 'value',
    event: 'priceInput'
  },

  data: function () {
    return {
      input: this.value
    }
  },

  created: function (event) {
    this.$emit('priceInput', this.price_to_num(this.value))
  },

  mounted() {
    this.input = this.price(this.value);
  },

  watch: {
    value: function (val) {
      this.input = this.price(this.value);
    }
  },

  computed: {
    priceString: function () {
      return this.input == null ? "" : this.input.toString().replace(/,/g, "").num2persian() + " ریال";
    }
  },

  methods: {
    keyUp: function (event) {
      this.input = this.to_money(this.input, event);
    },
    handleInput(e) {
      this.$emit('priceInput', this.price_to_num(this.input))
    },
    price_to_num: function (input) {
      try {
        if (input === undefined) return '';
        let str1 = input.toString().trim();
        if (str1 === '') return '';
        return this.en(str1.replace(/,/img, ''));
      } catch (e) {
        return input;
      }
    },
    to_money: function (input, event = null) {
      try {
        if (event != null) {
          if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
          }
        }

        let num = input.replace(/,/g, '');
        return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
    isNumberKey: function (evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  }
}
</script>

<style scoped>

</style>
